import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';

export interface JobStatusCounts {
  total: number;
  active: number;
  draft: number;
  scheduled: number;
  paused: number;
  closed: number;
}

interface StatusCountsResponse {
  message: string;
  data: JobStatusCounts;
}

/**
 * Hook for fetching job counts for each status
 * Uses the single status-count endpoint instead of multiple requests
 */
export const useManageJobsCounts = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['manageJobsCounts'],
    queryFn: async () => {
      const response = await apiClient.get<StatusCountsResponse>('/assessment/status-count/');
      return response.data.data;
    },
    staleTime: 30000, // Cache for 30 seconds
    refetchOnWindowFocus: false,
  });

  return {
    counts: data || {
      total: 0,
      active: 0,
      draft: 0,
      scheduled: 0,
      paused: 0,
      closed: 0,
    },
    isLoading,
    error,
  };
};
